import {} from '@ts/common/matomo';
import '@ts/pages/page-defaults';
const optOut = document.getElementById('optOutMatomo');
const optOutMatomoLabelIn = document.getElementById('optOutMatomoLabelIn');
const optOutMatomoLabelOut = document.getElementById('optOutMatomoLabelOut');
function setOptOutText() {
    console.log('setOptOutText', optOut, optOut?.checked, optOutMatomoLabelIn, optOutMatomoLabelOut);
    if (optOut === null || optOutMatomoLabelIn === null || optOutMatomoLabelOut === null) {
        console.error('optOut elm not found');
        return;
    }
    if (optOut.checked != true) {
        optOutMatomoLabelOut.classList.remove('hidden');
        optOutMatomoLabelIn.classList.add('hidden');
    }
    else {
        optOutMatomoLabelIn.classList.remove('hidden');
        optOutMatomoLabelOut.classList.add('hidden');
    }
}
// TOOD: test this
optOut?.addEventListener('change', () => {
    console.log('change optOut');
    setOptOutText();
});
if (optOut !== null) {
    optOut.checked = false;
    setOptOutText();
    document.addEventListener('initializedMatomo', function (event) {
        // console.log('initializedMatomo event');
        function setChecked(element) {
            window._paq.push([
                function () {
                    element.checked = !this.isUserOptedOut();
                },
            ]);
        }
        const optOut = document.getElementById('optOutMatomo');
        optOut.addEventListener('click', function () {
            if (this.checked) {
                window._paq.push(['forgetUserOptOut']);
            }
            else {
                window._paq.push(['optUserOut']);
            }
        });
        setChecked(optOut);
        setOptOutText();
    });
}
else {
    console.error('optOut elm not found');
}
